import * as React from 'react';
import * as styles from './Treeview.css'
import { TreeViewItem } from './treeViewItem/TreeViewItem';
import { ITreeViewItem } from '../../interfaces/ITreeViewItem';
import { Provider } from 'mobx-react';
import { TreeViewStore } from './TreeViewStore';
import { configure } from 'mobx';

export interface ITreeviewProps {
  items: ITreeViewItem[];
  highlightColor?: string;
  label?: string;
  actionType?: "Checkbox" | "Radio";
  expanded?: boolean;
  structureType?: "Folder" | "Arrow";
  onChange?: (items: ITreeViewItem[]) => void;
  onSelect?: (item: ITreeViewItem) => void;
  isIE?: boolean;
  disabled?: boolean;
  useColors?: boolean;
  style?: React.CSSProperties;
}

export interface ITreeViewState {
}

export class IATreeview extends React.Component<ITreeviewProps, ITreeViewState> {

  private treeViewStore: TreeViewStore;

  constructor(props: ITreeviewProps) {
    super(props);
    this.state = {
    }
    this.treeViewStore = new TreeViewStore();
    configure({
      isolateGlobalState: true,
      enforceActions: "never"
    });
    this.treeViewStore.highlightColor = this.props.highlightColor ? this.props.highlightColor : "#333333";
    this.treeViewStore.actionType = this.props.actionType;
    this.treeViewStore.expanded = this.props.expanded;
    this.treeViewStore.structureType = this.props.structureType ? this.props.structureType : "Arrow";
    this.treeViewStore.treeView = this.props.items;
  }

  componentWillReceiveProps(props: ITreeviewProps): void {
    if (props.items !== this.treeViewStore.treeView) {
      this.treeViewStore.treeView = props.items;
    }
  }

  public render(): JSX.Element {
    let hasChildren = false;
    this.treeViewStore.treeView?.forEach((item) => {
      if (item.children?.length > 0) {
        hasChildren = true;
      }
    })
    if (!this.props.isIE) {
      const items = [];
      if (this.treeViewStore.treeView && this.treeViewStore.treeView.length > 0) {
        this.treeViewStore.treeView.forEach((item: ITreeViewItem, index) => {
          items.push(
            <TreeViewItem
              key={item.guid ? `${item.guid}_${index}` : `${item.title}_${index}`}
              item={item}
              level={1}
              disabled={this.props.disabled}
              childIsChecked={() => {
                this.props.onChange(this.treeViewStore.treeView);
              }}
              onChange={this.props.onChange != undefined ? () => {
                const uniqueItems: ITreeViewItem[] = [];
                this.treeViewStore.treeView?.forEach((item: ITreeViewItem) => {
                  let addedAlready = false;
                  uniqueItems?.forEach((alreadyAddedItem: ITreeViewItem) => {
                    if (JSON.stringify(alreadyAddedItem) === JSON.stringify(item)) {
                      addedAlready = true;
                    }
                  });
                  if (!addedAlready) {
                    uniqueItems.push(item);
                  }
                });
                this.props.onChange(uniqueItems);
              } :
                undefined
              }
              onSelect={this.props.onSelect != undefined ? (selectedItem: ITreeViewItem) => this.props.onSelect(selectedItem) : undefined}
              showIcon={item.showIcon}
              iconProps={item.iconOption}
              useColors={this.props.useColors}
            />
          );
        });
      }
      const style = this.props.style ?? {};
      return (
        <Provider treeViewStore={this.treeViewStore}>
          <div
            className={styles.IATreeViewWrapper}
            style={{
              ...style,
              opacity: this.props.disabled ? 0.5 : 1,
              marginLeft: hasChildren ? 20 : -5
            }}
          >
            {this.props.label &&
              <div className={styles.IAlabel}>{this.props.label}</div>
            }
            <ul className={styles.IATreeView}
            // style={{
            //   paddingLeft: (this.props.structureType === "Folder") ? 48 : 24
            // }}
            >
              {items}
            </ul>
          </div>
        </Provider>
      )
    } else {
      return (<div></div>);
    }
  }
}